var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "red",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0a14 14 0 110 28 14 14 0 010-28zM7.875 13.125a.875.875 0 000 1.75h10.138l-3.758 3.756a.875.875 0 101.24 1.238l5.25-5.25a.875.875 0 000-1.239l-5.25-5.25a.877.877 0 00-1.24 1.24l3.758 3.755H7.875z",
    fill: "#fff",
    opacity: 0.8
  })));
}
export default SvgSliderArrow;